import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {TEXT_MAX_LENGTH} from '../text_input_constants';
import styles from './CharacterCount.less';

class CharacterCount extends React.PureComponent {
  render() {
    const {isInvalid, queryLength} = this.props;
    return (
      <div
        className={classNames({
          [styles.dlCharacterCount]: true,
          'float-end': true,
          [styles.dlInvalid]: isInvalid,
        })}
      >
        <span className={styles.dlCharacterCountText}>
          <FormattedMessage
            id={'textInput.charactersRemaining'}
            defaultMessage={'Characters remaining: {count}'}
            description={'text for remaining characters in text area'}
            values={{
              count: Number(TEXT_MAX_LENGTH - queryLength).toLocaleString('cs'),
            }}
          />
        </span>
        <i
          className={classNames({
            'fas fa-check': !isInvalid,
            'fas fa-times': isInvalid,
          })}
        />
      </div>
    );
  }
}

CharacterCount.displayName = 'CharacterCount';

CharacterCount.propTypes = {
  isInvalid: PropTypes.bool.isRequired,
  queryLength: PropTypes.number.isRequired,
};

export default CharacterCount;
